const GET_EMAILS_LEFT_ERROR_TEXT = "Une erreur est survenue lors du chargement des e-mails restants.";
const SEND_EMAIL_ERROR_TEXT = "Une erreur est survenue lors de l'envoi de l'e-mail.";
const ADD_MARKETING_IMAGE_ERROR_TEXT = "Une erreur est survenue lors du chargement de l'image.";

export const GET_EMAILS_LEFT_ERROR = GET_EMAILS_LEFT_ERROR_TEXT;
export const SEND_EMAIL_ERROR = SEND_EMAIL_ERROR_TEXT;
export const ADD_MARKETING_IMAGE_ERROR = ADD_MARKETING_IMAGE_ERROR_TEXT;


// WEBPACK FOOTER //
// ./src/errors/marketing.js